import { useParams } from "react-router-dom";

export const STRUCTURE = "structure";
export const EMPLOYEES = "employees";

export function useTabParam() {
  const { tab } = useParams<{ tab: string }>();

  return {
    tab,
  };
}
